export default __webpack_public_path__ + "static/media/blog-post-layout-03-img-07.6636d281.jpg";